import React, { Component } from 'react';
import cl from 'classnames';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

export default class DateTime extends Component {
    render() {
        const { className, dateFormat, inputProps, ...rest } = this.props;
        return (
            <Datetime
                className={cl(className, 'datetime', { 'datetime--time-only': !dateFormat })}
                inputProps={{ className: 'input__item', ...inputProps }}
                dateFormat={dateFormat}
                {...rest}
            />
        );
    }
}
DateTime.defaultProps = {
    className: '',
    inputProps: {},
    dateFormat: true,
};
DateTime.propTypes = {
    className: PropTypes.string,
    inputProps: PropTypes.object,
    dateFormat: PropTypes.bool,
};
